<template>
  <div
    v-if="isLoading"
    class="loader"
  />
  <form
    v-else
    class="clinic-form"
    @submit.prevent="createClinic"
  >
    <div>
      <ul>
        <li>
          <input
            ref="clinicName"
            v-model="clinicName"
            type="text"
            placeholder="クリニック名を入力してください。"
          >
        </li>
        <li>
          <button
            :disabled="clinicName == ''"
            type="submit"
            class="btn"
          >作成する</button>
        </li>
      </ul>
    </div>
  </form>
</template>
<script>
  import OrganizationApi from '../../../api/organizations.js'

  export default {
    components: {
    },
    props: {
    },
    data () {
      return {
        clinicName: [],
        isLoading: false
      }
    },
    mounted () {
      this.$refs.clinicName.focus();
    },
    methods: {
      createClinic() {
        this.isLoading = true
        OrganizationApi.addClinic(this.organizationId, { name: this.clinicName }).then((res) => {
          this.$emit('created', res.data.clinic)
        }).finally(() => {
          this.isLoading = false
        })
      }
    }
  }
</script>
<style scoped>
.clinic-form li {
  padding: 20px 0;
  height: auto;
}
</style>
